import { CHAT_ENDPOINT } from '@Env/variables';
import { createAxiosInstance } from './axios';
import { ChatHistory } from '@Models/types';

export const aiChatAPI = (logout: () => void) => {
  const axios = createAxiosInstance(logout, CHAT_ENDPOINT);

  return {
    getAITokenUsage: async (chatId: string | null) => {
      const res = await axios.post('/api/getAITokenUsage', {
        chatId,
      });
      return res.data;
    },

    getChatHistory: async () => {
      const res = await axios.get('/api/getChatHistory');
      return res.data;
    },

    getChatMessages: async (chatId: string | null) => {
      const res = await axios.post<ChatHistory[]>('/api/getChatMessages', {
        chatId,
      });
      return res.data;
    },

    renameChatHistory: async (title: string, conversationId: string) => {
      const res = await axios.post('/api/renameChatHistory', {
        title,
        conversationId,
      });
      return res.data;
    },

    deleteChatHistory: async (conversationId: string) => {
      const res = await axios.post('/api/deleteChatHistory', {
        conversationId,
      });

      return res.data;
    },
  };
};
